export default function isDateIsBetweenTwoDates(
  startDate: string,
  endDate: string,
  date = '',
): boolean {
  return new Date(date) >= new Date(startDate) && new Date(date) <= new Date(endDate);
}
